import { RouteRecordRaw } from 'vue-router';

import { ROUTE_NAMES } from '@/constants';

import { toNonVueRoute } from './utils';

const deliveryProdiverRoutes: RouteRecordRaw[] = [
  // Legacy
  toNonVueRoute({ path: 'deliveries/', name: ROUTE_NAMES.DELIVERIES }),
];

export default deliveryProdiverRoutes;
